import React, { useEffect, useState } from 'react';
import ProfileSettings from '@Services/ProfileSettings';

export default function WithCombinedInfoComponent({ loaded, WrappedComponent, ...props }) {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    const loadCombinedInfo = async () => {
      const combinedInfo = await ProfileSettings.loadCombineInfo();
      if (isMounted) {
        loaded(props, combinedInfo);
      }
    };
    setIsMounted(true);
    loadCombinedInfo();
    return () => {
      setIsMounted(false);
    };
  }, [isMounted, props, loaded]);
  return <WrappedComponent {...props} />;
}
